import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";
import moment from 'moment';

export function getSupplierAccounts(context) { //20250213
    const {
        suppliers,
        reconciliations,
        currencies,
        exchangerates,
        basecurrency
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'suppliers')

    const data = [];

    let currencysymbol = currencies.find(curr => curr.id == basecurrency)?.symbol

    suppliers.forEach((account) => {
        let accountledger = filteredledgerdata
            .filter(data => data.accountid == account.id)

        let reconciliationdate = ''
        let cashreconciliations = reconciliations
            .filter(data => data.accounttype == 'suppliers' && data.accountid == account.id)
            .sort((a, b) => b.ts - a.ts)[0]
        if (cashreconciliations) {
            reconciliationdate = moment.unix(cashreconciliations.ts).format("D/MMM/YYYY");
        }

        data.push({
            ...account,
            currencyid: basecurrency,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledger, exchangerates, basecurrency, 'suppliers'),
            reconciled: reconciliationdate
        });
    });

    data.sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
        if (nameComparison === 0) {
            return parseFloat(a.balance) - parseFloat(b.balance);
        }
        return nameComparison;
    });

    return data;
}